module.exports = __webpack_public_path__ + "static/media/prev.26083d74.svg";